export default function formatCurrency(number) {
    const options = { style: 'currency', currency: 'USD' };

    // Check if the price has cents
    if (number % 1 !== 0) {
      // Price has cents, include them in the formatting
      options.minimumFractionDigits = 2;
      options.maximumFractionDigits = 2;
    } else {
      // Price does not have cents, omit them in the formatting
      options.minimumFractionDigits = 0;
      options.maximumFractionDigits = 0;
    }
  
    return new Intl.NumberFormat('en-US', options).format(number);
}